import type { FC, ReactElement } from 'react';
import { Children, cloneElement } from 'react';

import type { ShadowBoxProps } from './ShadowBox';
import { ShadowBox } from './ShadowBox';

/**
 * Elevatable <br>
 * Elevate on hover <br>
 * box-shadow effect on hover
 */
export const Elevatable: FC<ShadowBoxProps & { children: ReactElement[]}> = ({
  children,
  transitionDuration,
  transitionTimingFunction,
  transitionDelay,
  min,
  max,
  minColor,
  maxColor,
  ...props
}) => (
  <ShadowBox
    transitionDuration={transitionDuration}
    transitionTimingFunction={transitionTimingFunction}
    transitionDelay={transitionDelay}
    minColor={minColor}
    maxColor={maxColor}
    max={max}
    min={min}
  >
    {Children.map( children, (child, index) => cloneElement( child, { ...props } ) )}
  </ShadowBox>
);
